import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "../components/landingpage/sections/Navbar";

const UnauthorizedPage = () => {
    return (
        <>
        <Navbar />
        <div className="container text-center mt-5">
            <h1 className="text-danger">Unauthorized Access</h1>
            <p>You don't have permission to access this page with your account type.</p>
            <Link to="/" className="btn btn-primary">Return to Home</Link>
        </div>
        </>
    );
};

export default UnauthorizedPage;